import { render, staticRenderFns } from "./ListWithProps.vue?vue&type=template&id=0e887c1c&"
import script from "./ListWithProps.vue?vue&type=script&lang=js&"
export * from "./ListWithProps.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports